// Generated by Claude Code
import { cs, de, enUS, es, fr, hr, it, nl, pl, sk, srLatn, tr, uk, type Locale } from 'date-fns/locale'

const DATE_FNS_LOCALES: Record<string, Locale> = { en: enUS, nl, fr, de, it, pl, es, sr: srLatn, hr, uk, tr, cs, sk }

/** The date-fns locale for a UI language code, falling back to en-US. */
export function dateFnsLocale(language: string): Locale {
  return DATE_FNS_LOCALES[language] ?? enUS
}
